import { Input, Button, ButtonVariant } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { type UpdateEmailStep, UpdateEmailStepEnum, UpdateEmailField } from '../../types/email/email-types'

export const ChangeEmailStep: FC<UpdateEmailStep> = ({ ctaOnClick, isLoading }) => {
  const STEP = UpdateEmailStepEnum.CHANGE

  const { t } = useTranslation('features-settings')

  const { register } = useFormContext()

  return (
    <div className="flex flex-col gap-4">
      {/* put some error handling field here for email validation */}
      <Input
        {...register(UpdateEmailField.EMAIL)}
        id={UpdateEmailField.EMAIL}
        label={t(`update_email.${STEP}.input_label`)}
        isPII
      />
      <Button id="changeEmailContinue" onClick={ctaOnClick} isLoading={isLoading} variant={ButtonVariant.Primary}>
        {t('settings.personal_info.change.continue')}
      </Button>
    </div>
  )
}
